import React from "react";

export type InputFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  className?: string;
  inputClassName?: string;
  prefix?: string;
};

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ label, className = "", inputClassName = "", prefix, ...props }, ref) => {
    return (
      <div className={`w-full ${className}`}>
        {label && (
          <label className="block text-sm mb-1 font-medium text-color ">
            {label} {props.required && <span className="text-red-500">*</span>}
          </label>
        )}

        {/* Wrapper for input and prefix */}
        <div className="relative">
          {prefix && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-semibold select-none pointer-events-none">
              {prefix}
            </span>
          )}

          <input
            {...props}
            ref={ref}
            inputMode={props.type === "number" ? "numeric" : undefined}
            pattern={props.type === "number" ? "[0-9]*" : undefined}
            onKeyDown={(e) => {
              if (
                props.type === "number" &&
                ["e", "E", "+", "-"].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            className={`w-full rounded-md px-2 border border-gray-200 bg-white py-2 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300 ${
              prefix ? "pl-12" : "pl-3"
            } ${inputClassName} ${
              props.readOnly
                ? "pointer-events-none bg-gray-100 text-gray-500 cursor-not-allowed"
                : ""
            }`}
          />
        </div>
      </div>
    );
  },
);

InputField.displayName = "InputField";

export default InputField;
